import * as XLSX from 'xlsx';
import type { TFunction } from 'i18next';
import { writeExcelFile } from '../../utils/excelExport';
import type { TbfDirection, TbfRankingRow } from '../../utils/tbfApi';
import type { TbfCountry } from '../../pages/tbf/TbfCountryList';

interface TbfExportOptions {
    countryByCode: Record<number, TbfCountry>;
    direction: TbfDirection;
    position: number;
    placeOf: (row: TbfRankingRow) => number;
    t: TFunction;
    language: string;
}

// Values, years and ranks stay numeric so Excel can sort them.
const TbfExportService = (
    results: TbfRankingRow[],
    { countryByCode, direction, position, placeOf, t, language }: TbfExportOptions
) => {

    const exportToExcel = () => {
        if (!Array.isArray(results) || results.length === 0) {
            return;
        }

        const header = [
            t('tbf.columns.country'),
            t('tbf.columns.indicator'),
            t('tbf.columns.category'),
            t('tbf.columns.value'),
            t('tbf.columns.unit'),
            t('tbf.columns.year'),
            t('tbf.columns.rank'),
            t('tbf.columns.rankedCountries'),
        ];

        const rows = results.map((row) => [
            countryByCode[row.c_code]?.name ?? row.c_code,
            row.indicator,
            row.category,
            row.value ?? null,
            row.unit,
            row.year,
            placeOf(row),
            row.ranked_countries,
        ]);

        const worksheet = XLSX.utils.aoa_to_sheet([header, ...rows]);
        worksheet['!cols'] = [
            { width: 22 },
            { width: 70 },
            { width: 30 },
            { width: 16 },
            { width: 18 },
            { width: 8 },
            { width: 8 },
            { width: 18 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'OIC-TBF');
        if (language === 'ar') {
            workbook.Workbook = { Views: [{ RTL: true }] };
        }

        const date = new Date().toISOString().split('T')[0];
        writeExcelFile(workbook, `oic-tbf-${direction}-${position}-${date}.xlsx`);
    };

    return { exportToExcel };
};

export default TbfExportService;
